<template>
  <ListingBlockLayout title="Podcasts" class="podcasts-block-skeleton">
    <PodcastCardSkeleton v-for="i in numberOfCardsToRender" :key="i" />
  </ListingBlockLayout>
</template>

<script setup lang="ts">
import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import PodcastCardSkeleton from '@/app/components/listing/skeleton-loaders/PodcastCardSkeleton.vue'

const numberOfCardsToRender = 4
</script>

<style lang="scss" scoped>
.podcasts-block-skeleton {
  --listing-block-number-of-columns: 4;
}
</style>
